export enum NgZorroIconTheme {
  TwoTone = 'twotone',
  Outline = 'outline',
  Fill = 'fill'
}
